@if (
  state.isFilling &&
  !state.payerEnroll &&
  !state.showSavedCard &&
  !state.pinSection &&
  !state.verifyingTransfer &&
  !state.error
) {
  <form
    autocomplete="off"
    [formGroup]="cardPaymentForm"
    (ngSubmit)="onSubmitBtnClicked()"
  >
    <div class="zp:relative">
      <label
        for="card-number"
        class="zp:text-xs zp:font-medium zp:text-ZTN-500 zp:pb-2 zp:block"
        >Card Number</label
      >
      <input
        id="card-number"
        placeholder="0000 0000 0000 0000"
        title="Please enter your card number"
        (input)="onCardNumberInput($event)"
        formControlName="cardNo"
        name="cardNo"
        class="cc-number-input zp:relative zp:border zp:border-ZTN-300 zp:w-full zp:rounded zp:py-3 zp:px-4 zp:text-ZTN-900 zp:placeholder:font-light zp:focus:border-ZTG-500 zp:focus:ring-ZTG-500 zp:outline-none zp:placeholder:text-ZTN-300 zp:h-[48px] zp:text-sm"
        type="text"
        required
      />
      <span class="zp:absolute zp:top-1/2 zp:right-5">
        @switch (cardType) {
          @case ("mastercard") {
            <svg-icon
              name="master-card-icon"
              svgClass="img-fluid w-30"
            ></svg-icon>
          }
          @case ("visa") {
            <svg-icon name="visa-icon" svgClass="img-fluid w-30"></svg-icon>
          }
          @case ("verve") {
            <svg-icon name="verve-icon" svgClass="img-fluid w-30"></svg-icon>
          }
          @case ("afrigo") {
            <svg-icon name="afrigo-icon" svgClass="img-fluid w-30"></svg-icon>
          }
        }
      </span>
    </div>
    @if (isInternationalCard) {
      <p class="zp:text-xs zp:text-ZTO-700 zp:mt-2">
        This is a foreign issued card. International fees will apply
      </p>
    }
    <div
      class="zp:grid zp:grid-cols-2 zp:gap-4"
      [ngClass]="{ 'zp:py-3': showPin, 'zp:pt-5': !showPin }"
    >
      <div>
        <label
          for="card-expiry"
          class="zp:text-xs zp:font-medium zp:text-ZTN-500 zp:pb-2 zp:block"
          >Expiry Date</label
        >
        <input
          id="card-expiry"
          placeholder="MM/YY"
          maxlength="5"
          (input)="onExpiryInput($event)"
          formControlName="expiryDate"
          name="expiryDate"
          title="Please enter your card expiry date"
          class="cc-expiry-input zp:border zp:border-ZTN-300 zp:w-full zp:rounded zp:py-3 zp:px-4 zp:text-ZTN-900 zp:placeholder:font-light zp:placeholder:text-ZTN-300 zp:h-[48px] zp:text-sm zp:focus:border-ZTG-500 zp:focus:ring-ZTG-500 zp:outline-none"
          type="text"
          required
        />
      </div>
      <div>
        <label
          for="card-cvv"
          class="zp:text-xs zp:font-medium zp:text-ZTN-500 zp:pb-2 zp:block"
          >CVV</label
        >
        <input
          id="card-cvv"
          (keypress)="checkDigit($event)"
          (input)="onCvvInput($event)"
          maxlength="3"
          formControlName="cvv"
          name="cvv"
          placeholder="123"
          title="Please enter your card cvv"
          class="zp:border zp:border-ZTN-300 zp:w-full zp:rounded zp:py-3 zp:px-4 zp:text-ZTN-900 zp:placeholder:font-light zp:placeholder:text-ZTN-300 zp:h-[48px] zp:text-sm zp:focus:border-ZTG-500 zp:focus:ring-ZTG-500 zp:outline-none"
          type="password"
          required
        />
      </div>
    </div>
    @if (showPin) {
      <div>
        <label
          for="card-pin"
          class="zp:text-xs zp:font-medium zp:text-ZTN-500 zp:pb-2 zp:block"
          >Pin</label
        >
        <input
          id="card-pin"
          (keypress)="checkDigit($event)"
          (input)="onPinInput($event)"
          maxlength="6"
          formControlName="pin"
          name="pin"
          title="Please enter your card pin"
          class="zp:border zp:border-ZTN-300 zp:w-full zp:rounded zp:py-2.5 zp:px-4 zp:text-ZTN-900 zp:placeholder:font-light zp:placeholder:text-ZTN-300 zp:h-[48px] zp:text-sm zp:focus:border-ZTG-500 zp:focus:ring-ZTG-500 zp:outline-none"
          type="password"
          required
        />
      </div>
    }
    <div class="zp:pt-4 zp:pb-6 zp:flex zp:items-center">
      <input
        type="checkbox"
        class="omni-input"
        id="omni-check"
        (change)="saveCard($event)"
      />
      <label
        class="zp:font-medium zp:text-ZTN-500 zp:pl-2 zp:text-sm"
        for="omni-check"
        >Remember this card</label
      >
    </div>
    @if (amount) {
      <div>
        <button
          class="zp:bg-ZTG-BC zp:text-center zp:text-white zp:w-full zp:rounded-lg zp:font-bold zp:text-sm zp:py-3 zp:cursor-pointer"
          type="submit"
          [ngClass]="{
            'zp:bg-ZTG-BC zp:cursor-pointer': cardPaymentForm.valid,
            'zp:bg-ZTG-300 zp:cursor-not-allowed': !cardPaymentForm.valid,
            'omni-btn-loading': loading,
          }"
          [disabled]="!cardPaymentForm.valid"
        >
          <span class="zp:leading-6"
            >Pay <span>{{ currency }}</span>
            {{ amount ? (amount | currency: " ") : "" }}</span
          >
        </button>
        @if (hasSavedCard) {
          <button
            (click)="fetchSavedCards()"
            class="zp:mt-4 zp:text-sm zp:font-semibold zp:leading-4 zp:text-ZTN-900 zp:text-center zp:cursor-pointer zp:w-full zp:mx-auto"
            type="button"
          >
            Pay with a saved card
          </button>
        }
        <span></span>
      </div>
    }
    <!-- <div class="row pt-4">
                <div class="form-group col-md-12 mb-3">
                  <label class="omni-label">Card Number</label>
                  <div class="card-number-input">
                    <span class="card-type-icon">
                      <ng-container [ngSwitch]="cardType">
                        <ng-template ngSwitchCase="mastercard">
                          <svg-icon
                            name="master-card-icon"
                            svgClass="img-fluid w-30"
                          ></svg-icon>
                        </ng-template>
                        <ng-template ngSwitchCase="visa">
                          <svg-icon name="visa-icon" svgClass="img-fluid w-30"></svg-icon>
                        </ng-template>
                        <ng-template ngSwitchCase="verve">
                          <svg-icon
                            name="verve-icon"
                            svgClass="img-fluid w-30"
                          ></svg-icon>
                        </ng-template>
                        <ng-template ngSwitchCase="afrigo">
                          <svg-icon
                            name="afrigo-icon"
                            svgClass="img-fluid w-30"
                          ></svg-icon>
                        </ng-template>
                      </ng-container>
                    </span>
                    <input
                      class="omni-form-control card-type cc-number-input"
                      formControlName="cardNo"
                      name="cardNo"
                      type="text"
                      id="pan"
                      placeholder="5289 8976 8765 7878"
                      required
                      />
                  </div>
                </div>
                <div class="form-group col-md-8 mb-3">
                  <label class="omni-label">Expiry (MM/YY)</label>
                  <div class="group-input">
                    <input
                      class="omni-form-control cc-expiry-input"
                      maxlength="5"
                      formControlName="expiryDate"
                      name="expiryDate"
                      id="exp"
                      type="text"
                      placeholder="MM/YY"
                      required
                      />
                  </div>
                </div>
                <div class="form-group col-md-4 mb-3">
                  <label class="omni-label">CVV</label>
                  <div class="group-input">
                    <input
                      class="omni-form-control"
                      (keypress)="checkDigit($event)"
                      maxlength="3"
                      formControlName="cvv"
                      id="cvv"
                      name="cvv"
                      type="password"
                      placeholder="XXX"
                      required
                      />
                  </div>
                </div>
                <div class="form-group col-md-12 mb-3" *ngIf="showPin">
                  <label class="omni-label">Pin</label>
                  <div class="group-input">
                    <input
                      (keypress)="checkDigit($event)"
                      class="omni-form-control"
                      maxlength="6"
                      formControlName="pin"
                      id="pin"
                      name="pin"
                      type="password"
                      placeholder=""
                      required
                      />
                  </div>
                </div>
                <div class="form-group col-md-12 mb-3">
                  <div class="omni-checkbox">
                    <input
                      type="checkbox"
                      class="omni-input"
                      id="omni-check"
                      (change)="saveCard($event)"
                      />
                    <label class="omni-label" for="omni-check"
                      >Save card information</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-12 mt-2">
                    <div class="group-input">
                      <button
                        class="omni-btn omni-btn-primary omni-btn-block"
                        type="submit"
                        [disabled]="!cardPaymentForm.valid"
                        [ngClass]="{ 'omni-btn-loading': loading }"
                        >
                        <span
                          >Pay
                          {{
                          amount
                          ? (amount
                          | currency : transactionData.currency : "symbol-narrow")
                          : ""
                          }}</span
                          >
                        </button>
                        <button
                          *ngIf="hasSavedCard"
                          (click)="fetchSavedCards()"
                          class="omni-btn omni-btn-transparent text-primary"
                          type="button"
                          >
                          Pay with a saved card
                        </button>
                        <span></span>
                      </div>
                    </div>
                  </div> -->
  </form>
}

<!-- Saved Cards UI section -->
@if (
  state.showSavedCard &&
  !state.pinSection &&
  state.isFilling &&
  !state.verifyingTransfer &&
  !state.error
) {
  <form class="zp:h-full zp:flex zp:flex-col">
    <div class="zp:flex zp:flex-col zp:min-h-0">
      <div
        class="zp:flex zp:items-start zp:justify-start zp:gap-x-2 zp:shrink-0"
      >
        <svg-icon
          name="back-btn"
          svgClass="img-fluid w-30"
          class="zp:cursor-pointer zp:fill-ZTP-900 zp:stroke-ZTP-900"
          (click)="goBackToCardForm()"
        ></svg-icon>
        <label
          class="zp:mb-5 zp:block zp:text-ZTN-500 zp:text-sm zp:font-medium"
          >Your saved cards</label
        >
      </div>
      <div
        #savedCardsList
        (scroll)="onSavedCardsScroll()"
        class="zp:space-y-5 zp:min-h-0 zp:overflow-y-auto zp:pr-2 saved-cards-list"
      >
        @for (card of cards; track card; let i = $index) {
          <div
            class="zp:bg-white zp:flex zp:justify-between zp:items-center zp:border zp:p-4 zp:rounded-lg zp:cursor-pointer"
            (click)="selectSavedCard(card)"
            [ngClass]="{
              'zp:border-ZTG-500': paymentCard === card,
              'zp:border-ZTN-300': paymentCard !== card,
            }"
          >
            <div class="zp:flex zp:items-center zp:justify-start">
              <div class="me-3">
                <div class="mcard-label__type">
                  @switch (card.cardType) {
                    @case ("MASTERCARD") {
                      <svg-icon
                        name="master-card-icon"
                        svgClass="img-fluid w-30"
                      ></svg-icon>
                    }
                    @case ("VISA") {
                      <svg-icon
                        name="visa-icon"
                        svgClass="img-fluid w-30"
                      ></svg-icon>
                    }
                    @case ("VERVE") {
                      <svg-icon
                        name="verve-icon"
                        svgClass="img-fluid w-30"
                      ></svg-icon>
                    }
                    @case ("AFRIGO") {
                      <svg-icon
                        name="afrigo-icon"
                        svgClass="img-fluid w-30"
                      ></svg-icon>
                    }
                  }
                </div>
              </div>
              <div class="zp:ml-2">
                <span class="card-number">
                  {{ card.cardPan }}
                </span>
                <!-- <p class="card-name">
                                {{ card.cardName }}
                              </p> -->
              </div>
            </div>
            <span class="pay-type-select">
              <span>
                <input
                  class="omni-input"
                  [(ngModel)]="paymentCard"
                  [value]="card"
                  type="radio"
                  [checked]="cardChecked"
                  name="paymentCard"
                  [id]="'pay-card' + i"
                  (change)="selectSavedCard(card)"
                />
                <label [for]="'pay-card' + i"></label>
              </span>
            </span>
          </div>
          @if (paymentCard === card && isInternationalCard) {
            <p class="zp:text-xs zp:text-ZTO-700 zp:mt-1">
              You've selected a foreign-issued card. International fees will apply.
            </p>
          }
        }
      </div>
      @if (showSavedCardsArrow) {
        <div class="zp:flex zp:justify-center zp:pt-1 zp:shrink-0">
          <button
            type="button"
            aria-label="Scroll to more saved cards"
            class="saved-cards-scroll-btn zp:cursor-pointer zp:bg-white zp:rounded-full zp:size-9 zp:flex zp:items-center zp:justify-center zp:shadow-md zp:border zp:border-ZTN-300"
            (click)="scrollSavedCardsDown()"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 8L10 12L14 8"
                stroke="#4A1FB8"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      }
    </div>
    <div class="zp:mt-6 zp:shrink-0">
      <button
        class="zp:text-center zp:text-white zp:w-full zp:rounded-lg zp:font-bold zp:text-sm zp:py-3"
        type="submit"
        [ngClass]="{
          'zp:bg-ZTG-BC zp:cursor-pointer': paymentCard,
          'zp:bg-ZTG-300 zp:cursor-not-allowed': !paymentCard,
        }"
        [disabled]="!paymentCard"
        (click)="confirmPayment()"
      >
        <span class="zp:leading-6"
          >Pay <span>{{ currency }}</span>
          {{ amount ? (amount | currency: " ") : "" }}</span
        >
      </button>
    </div>
  </form>
}

<!-- OTP and Pin section -->
@if (state.pinSection && !state.verifyingTransfer) {
  <form class="payment-form zp:px-5" (ngSubmit)="onVerify()">
    <ng-container>
      <div class="pt-5">
        <div class="payment-form-title zp:text-center zp:pb-6">
          <p class="zp:text-ZTN-500 zp:text-sm zp:font-normal">
            Enter the OTP code that has been sent to <br />
            <span class="zp:text-sm zp:text-ZTN-900 zp:font-medium">
              your Email <span class="zp:text-ZTN-500">and</span> Phone Number.
            </span>
          </p>
        </div>
        <div class="form-group zp:pb-6">
          <app-otp-input
            [length]="6"
            [inputClass]="'otp-input'"
            (otpChange)="onOtpChange($event)"
          ></app-otp-input>
        </div>
        <div class="form-button zp:text-center">
          <button
            class="zp:bg-ZTG-BC zp:text-center zp:text-white zp:w-full zp:rounded-lg zp:font-bold zp:text-sm zp:py-3 zp:cursor-pointer"
            type="submit"
          >
            <span
              >Pay <span>{{ transactionData?.currency }}</span>
              {{
                amount
                  ? (amount
                    | currency: transactionData.currency : "symbol-narrow")
                  : ""
              }}
            </span>
          </button>
        </div>
        <div class="zp:w-full zp:text-center zp:pt-6">
          <div
            style="color: #677684"
            class="zp:font-medium zp:text-sm zp:text-ZTN-500"
          >
            OTP will expire in
            @if (display) {
              <span>{{ display }}</span>
            } @else {
              Loading...
            }
          </div>
          <!-- <a class="fz-14 code-resend-link"> Resend Now </a> -->
        </div>
      </div>
    </ng-container>
  </form>
}
@if (state.verifyingTransfer) {
  <div class="verification-loader">
    <span class="omni-spinner-text">Please wait</span>
    <div class="omni-spinner-border" role="status"></div>
  </div>
}
<ng-container>
  <iframe
    frameborder="0"
    id="threedscardinalTarget"
    style="display: none"
  ></iframe>
</ng-container>
@if (state.error) {
  <div
    class="zp:font-mont zp:flex zp:justify-center zp:items-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-ZTN-50 zp:p-1"
  >
    <div
      class="zp:text-center zp:bg-white zp:rounded-lg zp:py-4 zp:px-2 zp:basis-full"
    >
      <div class="zp:flex zp:justify-center zp:items-center zp:mb-3">
        <svg-icon name="warning" svgClass="img-fluid w-50"></svg-icon>
      </div>
      <div class="px-3">
        <div
          class="zp:font-semibold zp:text-lg zp:text-ZTN-900 zp:leading-5 zp:pb-2"
        >
          We could not process this transaction
        </div>
        <div class="zp:text-sm zp:text-ZTN-500 zp:font-normal zp:leading-5">
          <small class="zp:text-sm">
            {{ errorMessage }}
          </small>
        </div>
      </div>
    </div>
  </div>
}
